import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";
import { UnlinkLayerValidationStatus } from "../sidebar-toolbar-types";

export function useUnlinkLayerTooltip(status: UnlinkLayerValidationStatus) {
    const translate = useIventisTranslate();

    switch (status) {
        case UnlinkLayerValidationStatus.InvalidSelectionAmount:
            return translate(Content.map11.map_unlink_status.amount);
        case UnlinkLayerValidationStatus.InvalidTypeSelection:
        case UnlinkLayerValidationStatus.InvalidSelectionNonImport:
            return translate(Content.map11.map_unlink_status.type);
        case UnlinkLayerValidationStatus.InvalidPermissions:
            return translate(Content.map11.map_unlink_status.permissions);
        case UnlinkLayerValidationStatus.MapLoading:
            return translate(Content.map11.map_unlink_status.loading);
        case UnlinkLayerValidationStatus.Valid:
            return translate(Content.map11.map_unlink_status.explain);
        default:
            throw new Error(`Status of ${status} not handled`);
    }
}
